export enum ZoneShapeType {
    CIRCLE = 'CIRCLE',
    POLYGON = 'POLYGON',
}